import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import styles from 'styles';
import getLabels, { getPortLabelTypes } from '../PortManagement/common/Labels';

const resetScroll = () => {
    const containers = document.querySelectorAll('div[style*="overflow-y: auto"]');
    containers.forEach((container) => {
        container.scrollTop = 0;
    });
};

const PortsRow = ({ item }) => {
    const handleEditClick = () => {
        resetScroll();
    };

    const handleApproveClick = () => {
        resetScroll();
    };

    const labels = getPortLabelTypes(item);

    const {
        changes, _id, name, unLoCode, parent, country,
    } = item;

    return (
        <TableRow>
            <TableRowColumn style={styles.tableRowColumnCSS}>
                { name }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                { unLoCode }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                { country && country.name ? country.name : '' }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                { parent && parent.name ? parent.name : '' }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                { getLabels(labels) }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                {
                    changes && changes > 0 ?
                        <RaisedButton
                            label='Approve changes'
                            primary
                            containerElement={<Link to={`/regions/ports/approve/${_id}`} />}
                            onClick={handleApproveClick}
                        />
                        :
                        <RaisedButton
                            label='Edit'
                            primary
                            containerElement={<Link to={`/regions/ports/${_id}`} />}
                            onClick={handleEditClick}
                        />
                }
            </TableRowColumn>
        </TableRow>
    );
};

PortsRow.propTypes = {
    item: PropTypes.object,
};

PortsRow.defaultProps = {
    item: {},
};

export default PortsRow;



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Row.jsx